import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/AuthContext';
import Main from '../components/main';
import Header from '../components/header';

const RouteCRM = () => {

  const { user } = useAuth();

  useEffect(() => {

    let type = "";
    if (user) {
      type = user.type
    }

    if (!type) {
      window.location.assign("/login");
    }

  }, [])

  let type = "";
  if (user) {
    type = user.type
  }

  return type ?
    <>
      <Main sidebar={false} style={{marginTop: 0, width: "100vw", overflow: "hidden"}} >
        <div style={{position: "fixed", width: "100%", zIndex: 9999}}>
          <Header sidebar={false} type={type}/>
        </div>
        <Outlet/>
      </Main>
    </>
    : <></>
};

export default RouteCRM;